import React from 'react';
import { HiOutlineChevronUp, HiOutlineChevronDown } from "react-icons/hi";
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { Collapse, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import messages from '../../locale/messages';
import Link from '../Link';

import { adminLogout } from '../../actions/siteadmin/logout';
import { openHeaderModal } from '../../actions/siteadmin/modalActions';
import { choseToTheme } from '../../actions/currency/getCurrencyRates';
import history from '../../history'
import { validatePrivilege } from '../../helpers/adminPrivileges';
import { formatLocale } from '../../helpers/formatLocale';

//Images
import DashboardIcon from '../../../public/SideMenuIcons/analytics.svg';
import SiteSettingIcon from '../../../public/SideMenuIcons/siteSetting.svg';
import mobileAppIcon from '../../../public/SideMenuIcons/mobileSetting.svg';
import HomeSettingIcon from '../../../public/SideMenuIcons/homePageSetting.svg';
import ManageAdmins from '../../../public/SideMenuIcons/manageAdmin.svg';
import UserIcon from '../../../public/SideMenuIcons/manageUser.svg';
import ServiceProviderIcon from '../../../public/SideMenuIcons/manageServiceProvider.svg';
import CategoriesIcon from '../../../public/SideMenuIcons/mangeCategory.svg';
import ManageLocationIcon from '../../../public/SideMenuIcons/location.svg';
import BookingsIcon from '../../../public/SideMenuIcons/manageBookings.svg';
import PromoCodeIcon from '../../../public/SideMenuIcons/managePromoCode.svg';
import CompletedBooking from '../../../public/SideMenuIcons/completeBookings.svg';
import ChangePasswordIcon from '../../../public/SideMenuIcons/changePassword.svg';
import CancalBookingIcon from '../../../public/SideMenuIcons/cancelledBooking.svg';
import ManageCurrencyIcon from '../../../public/SideMenuIcons/manageCurrency.svg';
import RatingIcon from '../../../public/SideMenuIcons/ratings.svg';
import NotificationIcon from '../../../public/SideMenuIcons/manageNotification.svg';
import LogOutIcon from '../../../public/Icons/logout.svg';
import MainSiteIcon from '../../../public/Icons/mainSite.svg';
import PayOutManageIcon from '../../../public/SideMenuIcons/managePayout.svg';
import PayOutManageFaildIcon from '../../../public/SideMenuIcons/failedPayout.svg';
import CancelFaildIcon from '../../../public/SideMenuIcons/cancelReason.svg';
import StaticPageIcon from '../../../public/SideMenuIcons/contentManagement.svg';
import RightArrowIcon from '../../../public/Icons/right-arrow.png';
import ManageFareIcon from '../../../public/SideMenuIcons/manageFare.svg';
import LanguageIcon from '../../../public/Icons/languageIcon.svg';
import PrecautionIcon from '../../../public/SideMenuIcons/precautionNotification.svg';
import TrackingIcon from '../../../public/SideMenuIcons/tracking.svg';
import smsIcon from '../../../public/Icons/smsIcon.svg';
import selectedLightIcon from '../../../public/Icons/lightModeOn.svg';
import selectedDarkIcon from '../../../public/Icons/darkModeOn.svg';
import dropDownLightIcon from '../../../public/Icons/lightModeOff.svg';
import dropDownDarkIcon from '../../../public/Icons/darkModeOff.svg';
import siteAdminIcon from '../../../public/Icons/siteadminicon.png'
import configIcon from '../../../public/Icons/siteConfiguration.svg';

import s from './SideMenu.css';
import bt from '../../components/commonStyle.css';

class SideMenu extends React.Component {
  static defaultProps = {
    isSuperAdmin: false,
    privileges: []
  };
  constructor(props) {
    super(props);
    this.state = {
      isOpen: 0,
      location: '',
      homepageSettings: false
    }
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
  }
  componentDidMount() {
    this.setState({
      location: history.location.pathname
    })
  }
  componentDidUpdate(prevProps, prevState) {
    const { location } = this.props;
    if (prevState.location !== location) {
      this.setState({
        location
      })
    }
  }
  async openMenu() {
    this.setState({
      isOpen: 1,
    })
  }
  async openClose() {
    this.setState({
      isOpen: 0,
    })
  }
  render() {
    const { location } = this.state;
    const { adminLogout, isSuperAdmin, privileges, currentLocale, openHeaderModal, selectedTheme, choseToTheme } = this.props;
    let homePageSettingsArray = ['/siteadmin/homepage/banner', '/siteadmin/homepage/category', '/siteadmin/homepage/top-feature', '/siteadmin/homepage/user', '/siteadmin/homepage/partner', '/siteadmin/homepage/footer'];
    let manageAdminsLinks = ['/siteadmin/admin-users', '/siteadmin/admin-roles'];
    let menuActive = selectedTheme === "light" ? s.activeMenu : s.activeMenuDark;

    return (
      <div className={'sideMenu'}>
        <div className={cx(s.mobileHeader, 'bgBlackTwo')}>
          <div onClick={() => this.openMenu()}>
            <div className={cx('hamburger', 'textWhite')}>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </div>
          </div>
          <Link to={''} onClick={() => adminLogout()} className={cx(s.logoutIconMobile, 'logoutIconMobileRTL')}>
            <span className={'svgImg'}>
              <img src={LogOutIcon} className={cx(s.sideMenuIcon)} />
            </span>
          </Link>
        </div>
        <div className={cx({ [s.menuOpen]: this.state.isOpen == 1 }, { ["menuOpenRtl"]: this.state.isOpen == 1 }, s.sidebarContainer, "sidebarContainerRtl")}>
            <div className={cx(s.closeColor, 'closeColorMbRTL', 'textWhite', { [s.menuClose]: this.state.isOpen == 0 })} onClick={() => this.openClose()} >
              ×
          </div>
          <div className={cx(s.sidebarNavParent, 'hidden-print', 'bgBlackTwo')}>
            <div className={s.sideBarWelcome}>
                <h3 className={cx(bt.spaceTop1, bt.noMarginBottom, s.welcomeHeading)}>
                  <img src={siteAdminIcon} className={s.waveHand} />
                  <FormattedMessage {...messages.siteAdmin} />
                </h3>
            </div>
            <div className={s.sidebarNav}>
              <div onClick={() => { choseToTheme('light') }} className={'d-block d-sm-block d-md-block d-lg-none d-xl-none'}>
                <Link to="#" className={cx(s.sideNavitem, s.responsiveDasboradMargin, 'textWhite')} onClick={() => this.openClose()}>
                  <span className={cx(s.themeIconAlignment, { [s.selectedThemeColor]: selectedTheme === "light" })}>
                    {
                      selectedTheme && selectedTheme === "light" ?
                        <img src={selectedLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> :
                        <img src={dropDownLightIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                    }
                    <FormattedMessage {...messages.lightMode} />
                  </span>
                </Link>
              </div>
              <div onClick={() => { choseToTheme('dark') }} className={'d-block d-sm-block d-md-block d-lg-none d-xl-none'}>
                <Link to="#" className={cx(s.sideNavitem, 'textWhite')} onClick={() => this.openClose()}>
                  <span className={cx(s.themeIconAlignment, { [s.selectedThemeColorDark]: selectedTheme === "dark" })}>
                    {
                      selectedTheme && selectedTheme === "dark" ?
                        <img src={selectedDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} /> :
                        <img src={dropDownDarkIcon} alt='' className={cx(s.themeIcon, 'themeIconRTL')} />
                    }
                    <FormattedMessage {...messages.darkMode} />
                  </span>
                </Link>
              </div>
              <Link noLink onClick={(e) => openHeaderModal('languageModal')} className={cx(s.sideNavitem, s.displayTable, 'd-block d-md-none', s.languageSelector, 'sideNavitemRTL', 'textWhite')}>
                <span className={cx(s.languageIcon, s.displayTableCell, 'svgImg')}>
                  <img src={LanguageIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span className={cx(s.vtrMiddle, s.displayTableCell, s.languageIconLeft)}>
                  {formatLocale(currentLocale)}
                </span>
              </Link>
              <Link to={'/siteadmin'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin' })} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={DashboardIcon} className={s.sideMenuIcon} />
                </span>
                <span>
                  <FormattedMessage {...messages.manageDashboard} />
                </span>
              </Link>
              {
                validatePrivilege(1, privileges) &&
                <>
                  <Link to={'/siteadmin/settings/site'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/settings/site' })} onClick={() => this.openClose()}>
                    <span className={'svgImg'}>
                      <img src={SiteSettingIcon} className={cx(s.sideMenuIcon)} />
                    </span>
                    <span>
                      <FormattedMessage {...messages.siteSettings} />
                    </span>
                  </Link>
                  <Link to={'/siteadmin/settings/config'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/settings/config' })} onClick={() => this.openClose()}>
                    <span className={'svgImg'}>
                      <img src={configIcon} className={cx(s.sideMenuIcon)} />
                    </span>
                    <span>
                      <FormattedMessage {...messages.manageSiteConfig} />
                    </span>
                  </Link>
                </>
              }
              {
                validatePrivilege(1, privileges) &&
                <Link to={'/siteadmin/settings/mobile-app'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/settings/mobile-app' })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={mobileAppIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.mobileSettings} />
                  </span>
                </Link>
              }
              {
                /* Enam tab Home Page Settings lama diganti satu halaman Website
                   Content. Form lamanya masih ada di repo (HomeSettingsForm dkk)
                   dan mutation-nya masih terdaftar, tapi situs publik yang baru
                   tidak lagi membacanya — menampilkan tab yang menyimpan ke DB
                   tanpa efek apa pun ke halaman adalah jebakan, bukan fitur. */
                validatePrivilege(2, privileges) &&
                <Link to={'/siteadmin/website-content'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location === '/siteadmin/website-content' })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={HomeSettingIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.HomeSiteSettings} />
                  </span>
                </Link>
              }
              {isSuperAdmin && <div>
                <div id='Homepage' className={cx({ [menuActive]: manageAdminsLinks.includes(location) })}>
                  <Button bsStyle="link" className={cx(s.button, s.noBorderBtn, s.btnWidth, s.sideNavitem, s.positionRelative, 'sideNavitemRTL', 'btnWidthRTL', { [menuActive]: manageAdminsLinks.includes(location) })}
                    onClick={() => {
                      this.setState({
                        subAdmin: !this.state.subAdmin
                      })
                    }
                    }>
                    <span className={cx(s.vtrTop, s.iconWidth, s.iconWidth, s.displayTableCell, 'svgImg')}>
                      <img src={ManageAdmins} className={cx(s.sideMenuIcon)} />
                    </span>
                    <span>
                      <FormattedMessage {...messages.manageAdmin} />
                    </span>
                    {
                      this.state.subAdmin &&
                      <div className={cx(s.displayInlineBlock, s.downArrow, 'downArrowRTL')}>
                        <HiOutlineChevronUp className={s.navigationIcon} />
                      </div>
                    }

                    {
                      !this.state.subAdmin && <div className={cx(s.displayInlineBlock, s.downArrow, 'downArrowRTL')}><HiOutlineChevronDown className={s.navigationIcon} /></div>
                    }
                  </Button>
                </div>
                <Collapse in={this.state.subAdmin} className={s.subMenu}>
                  <div>
                    <Link to={'/siteadmin/admin-users'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/admin-users') })} onClick={() => this.openClose()}>
                      <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL', 'svgImg')}>
                        <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon)} />
                      </span>
                      <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageAdminUsers} />
                      </span>
                    </Link>
                    <Link to={'/siteadmin/admin-roles'} className={cx(s.sideNavitem, s.displayTable, s.sideNavitemCollapsePadding, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/admin-roles') })} onClick={() => this.openClose()}>
                      <span className={cx(s.vtrTop, s.iconWidth, s.displayTableCell, s.sideNavitemCollapse, 'rightArrowRTL', 'svgImg')}>
                        <img src={RightArrowIcon} className={cx(s.sideMenuIcon, s.sideNavitemCollapseIcon)} />
                      </span>
                      <span className={cx(s.vtrMiddle, s.sideNavitemCollapseText, s.displayTableCell, 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageAdminRoles} />
                      </span>
                    </Link>
                  </div>
                </Collapse>
              </div>
              }
              {
                validatePrivilege(3, privileges) &&
                <Link to={'/siteadmin/users'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', 'menuIconRTL', { [menuActive]: location.startsWith('/siteadmin/users') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={UserIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.usersMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(4, privileges) &&
                <Link to={'/siteadmin/partners'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', 'menuIconRTL', { [menuActive]: location.startsWith('/siteadmin/partners') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={ServiceProviderIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.partnerMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(5, privileges) &&
                <Link to={'/siteadmin/category'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/category') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.categoryMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(6, privileges) &&
                <Link to={'/siteadmin/sub-category'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/sub-category') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={CategoriesIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.subCategoryMenu} />
                  </span>
                </Link>}
              {
                validatePrivilege(7, privileges) &&
                <Link to={'/siteadmin/location'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/location') || location.startsWith('/siteadmin/add-location') || location.startsWith('/siteadmin/edit-location') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={ManageLocationIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.location} />
                  </span>
                </Link>}
              {
                validatePrivilege(8, privileges) &&
                <Link to={'/siteadmin/pricing/list'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/pricing') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={ManageFareIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageFare} />
                  </span>
                </Link>}
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/jobs'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/jobs') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={BookingsIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.bookingsMenu} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/direct-bookings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/direct-bookings') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={BookingsIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.directBookingMenu} />
                  </span>
                </Link>
              }
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/completed-jobs'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/completed-jobs') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={CompletedBooking} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageCompletedBooking} />
                  </span>
                </Link>}
              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/cancelled-jobs'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/cancelled-jobs') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={CancalBookingIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageCancelledBookings} />
                  </span>
                </Link>}

              {
                validatePrivilege(9, privileges) &&
                <Link to={'/siteadmin/schedule-jobs'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/schedule-jobs') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={BookingsIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageSchedule} />
                  </span>
                </Link>
              }

              {validatePrivilege(20, privileges) && <Link to={'/siteadmin/tracking'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/tracking' })} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={TrackingIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.tracking} />
                </span>
              </Link>}

              {validatePrivilege(19, privileges) && <Link to={'/siteadmin/sms-methods'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/sms-methods' })} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={smsIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.manageSmsMethod} />
                </span>
              </Link>}

              {
                validatePrivilege(11, privileges) &&
                <Link to={'/siteadmin/ratings'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/ratings' })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={RatingIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.ratings} />
                  </span>
                </Link>}
              {
                validatePrivilege(12, privileges) &&
                <Link to={'/siteadmin/promo-code/list'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/promo-code') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={PromoCodeIcon} className={s.sideMenuIcon} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.managePromoCode} />
                  </span>
                </Link>}
              <Link to={'/siteadmin/change/admin'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/change/admin' })} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={ChangePasswordIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.changePassword} />
                </span>
              </Link>
              {
                validatePrivilege(13, privileges) &&
                <Link to={'/siteadmin/notifications'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/notifications' })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={NotificationIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageNotifications} />
                  </span>
                </Link>}
              {isSuperAdmin && <Link to={'/siteadmin/currency'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/currency' })} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={ManageCurrencyIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.manageCurrency} />
                </span>
              </Link>}
              {
                validatePrivilege(14, privileges) &&
                <Link to={'/siteadmin/cancel-reasons'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/cancel-reasons') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={CancelFaildIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageCancelReason} />
                  </span>
                </Link>}
              {
                validatePrivilege(15, privileges) &&
                <Link to={'/siteadmin/payout'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/payout') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={PayOutManageIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.managePayout} />
                  </span>
                </Link>}
              {
                validatePrivilege(15, privileges) &&
                <Link to={'/siteadmin/failed-payout'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/failed-payout') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={PayOutManageFaildIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.manageFailedPayout} />
                  </span>
                </Link>}
              {
                validatePrivilege(16, privileges) &&
                <Link to={'/siteadmin/staticpage/manage'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/staticpage/manage') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={StaticPageIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.staticpageManagement} />
                  </span>
                </Link>}
              {
                validatePrivilege(17, privileges) &&
                <Link to={'/siteadmin/contentpage/manage'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/contentpage/manage') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={StaticPageIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.contentpageManagement} />
                  </span>
                </Link>}
              {
                validatePrivilege(21, privileges) &&
                <Link to={'/siteadmin/payment-gateway'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location.startsWith('/siteadmin/payment-gateway') })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={StaticPageIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.managePaymentGateWay} />
                  </span>
                </Link>}
              {
                validatePrivilege(18, privileges) &&
                <Link to={'/siteadmin/precaution-notification'} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', { [menuActive]: location == '/siteadmin/precaution-notification' })} onClick={() => this.openClose()}>
                  <span className={'svgImg'}>
                    <img src={PrecautionIcon} className={cx(s.sideMenuIcon)} />
                  </span>
                  <span>
                    <FormattedMessage {...messages.precautionNotification} />
                  </span>
                </Link>}
              <Link to={'/'} className={cx(s.sideNavitem, 'sideNavitemRTL', s.displayTable, s.hiddenMd)} onClick={() => this.openClose()}>
                <span className={'svgImg'}>
                  <img src={MainSiteIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.goToMainSite} />
                </span>
              </Link>
              <Link to={''} onClick={() => adminLogout()} className={cx(s.sideNavitem, s.displayTable, 'sideNavitemRTL', s.paddingBottomextra, s.hiddenMd)}>
                <span className={'svgImg'}>
                  <img src={LogOutIcon} className={cx(s.sideMenuIcon)} />
                </span>
                <span>
                  <FormattedMessage {...messages.logout} />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
  privileges: state.account && state.account.privileges,
  currentLocale: state.intl.locale,
  selectedTheme: state.currency.theme
});
const mapDispatch = {
  adminLogout,
  openHeaderModal,
  choseToTheme
};
export default compose(injectIntl,
  withStyles(s, bt),
  (connect(mapState, mapDispatch))
)(SideMenu);